window.theme = window.theme || {};

theme.toast = (() => {
  const MAX_VISIBLE = 4;
  const ALERT_TYPES = new Set(['error', 'warning']);
  const queue = [];
  const preRegistrationQueue = [];
  let containerPolite = null;
  let containerAlert = null;
  let visibleCount = 0;
  let idCounter = 0;

  function show(options) {
    const toast = {
      id: ++idCounter,
      type: options.type || 'info',
      message: options.message || '',
      duration: options.duration !== undefined ? options.duration : 4000,
      dismissible: options.dismissible !== false,
      action: options.action || null,
      icon: options.icon || null,
    };

    if (!containerPolite) {
      preRegistrationQueue.push(toast);
      return toast.id;
    }

    enqueue(toast);
    return toast.id;
  }

  function enqueue(toast) {
    queue.push(toast);
    theme.pubsub?.publish(theme.pubsub.events.TOAST_SHOW, toast);
    processQueue();
  }

  function processQueue() {
    while (visibleCount < MAX_VISIBLE && queue.length > 0) {
      const toast = queue.shift();
      render(toast);
    }
  }

  function render(toast) {
    visibleCount++;
    const container = ALERT_TYPES.has(toast.type) ? containerAlert : containerPolite;
    const el = document.createElement('div');

    el.className = `toast toast--${toast.type}`;
    el.dataset.toastId = toast.id;
    el.setAttribute('role', ALERT_TYPES.has(toast.type) ? 'alert' : 'status');
    el.setAttribute('aria-atomic', 'true');

    if (toast.icon) {
      const iconEl = document.createElement('span');
      iconEl.className = 'toast__icon';
      iconEl.setAttribute('aria-hidden', 'true');
      iconEl.appendChild(toast.icon);
      el.appendChild(iconEl);
    }

    const messageEl = document.createElement('span');
    messageEl.className = 'toast__message';
    messageEl.textContent = toast.message;
    el.appendChild(messageEl);

    if (toast.action) {
      const actionBtn = document.createElement('button');
      actionBtn.type = 'button';
      actionBtn.className = 'toast__action';
      actionBtn.textContent = toast.action.label;
      actionBtn.addEventListener('click', () => {
        toast.action.onClick?.();
        dismiss(toast.id);
      });
      el.appendChild(actionBtn);
    }

    if (toast.dismissible) {
      const dismissLabel = theme.locales?.accessibility?.toastDismiss;
      const dismissBtn = document.createElement('button');
      dismissBtn.type = 'button';
      dismissBtn.className = 'toast__dismiss';
      dismissBtn.setAttribute('aria-label', dismissLabel);
      dismissBtn.textContent = '×';
      dismissBtn.addEventListener('click', () => dismiss(toast.id));
      el.appendChild(dismissBtn);
    }

    container.appendChild(el);

    if (toast.duration > 0) {
      setTimeout(() => dismiss(toast.id), toast.duration);
    }
  }

  function dismiss(id) {
    const el = document.querySelector(`[data-toast-id="${id}"]`);
    if (!el || el.classList.contains('is-dismissing')) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    theme.pubsub?.publish(theme.pubsub.events.TOAST_DISMISS, { id });

    if (reducedMotion) {
      el.remove();
      visibleCount--;
      processQueue();
      return;
    }

    el.classList.add('is-dismissing');
    let done = false;
    const finalize = () => {
      if (done) return;
      done = true;
      el.removeEventListener('animationend', finalize);
      el.remove();
      visibleCount--;
      processQueue();
    };
    el.addEventListener('animationend', finalize);
    setTimeout(finalize, 300);
  }

  function flush() {
    preRegistrationQueue.splice(0).forEach(enqueue);
  }

  return { show, dismiss, _flush: flush, _processQueue: processQueue, _setContainers(p, a) { containerPolite = p; containerAlert = a; } };
})();

if (!customElements.get('theme-toast-container')) {
  class ThemeToastContainer extends HTMLElement {
    connectedCallback() {
      this.classList.add('toast-container');
      theme.toast._setContainers(
        this.querySelector('#toast-root'),
        this.querySelector('#toast-root-alert')
      );
      theme.toast._flush();
      theme.toast._processQueue();
    }

    disconnectedCallback() {
      theme.toast._setContainers(null, null);
    }
  }

  customElements.define('theme-toast-container', ThemeToastContainer);
}
